import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings.component';
import { SharedModule } from '../../shared/shared.module';
import { SettingsRoutingModule } from './settings-routing.module';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { IconsModule } from '../../icons/icons.module';
import { VerticalMenuModule } from '../../components/vertical-menu/vertical-menu.module';
import { ViewEndpointsModule } from '../service/view-endpoints/view-endpoints.module';
import { MatDividerModule } from '@angular/material/divider';
import { ViewSettingsUrlsModule } from '../service/view-settings-urls/view-settings-urls.module';



@NgModule({
  declarations: [
    SettingsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    SettingsRoutingModule,

    BreadcrumbModule,
    IconsModule,
    VerticalMenuModule,
    MatDividerModule,
    ViewEndpointsModule,
    ViewSettingsUrlsModule
  ]
})
export class SettingsModule { }
